import { defineStore, storeToRefs } from 'pinia'
import { ref, inject } from 'vue'
import { RequestService } from '../services/RequestService'
import { useEmployerStore } from './EmployerStore'
import { convertDate } from '../utils/index'

export const useNotesStore = defineStore('selectedNote', () => {
  const { simpleGet, post, put, del, createLog, handleErrors } = RequestService()

  const selectedNote = ref(null)
  const selectTab = ref({
    name: 'All',
    index: 0
  })
  const deleteNote = ref(false)
  const isCreatingNote = ref(false)
  const newNoteCreated = ref(false)
  const employerNotes = ref([])
  const functionsBaseUrl = inject('functionsBaseUrl')

  function setSelectedNote(note) {
    selectedNote.value = note
  }

  function clearSelectedNote() {
    selectedNote.value = null
  }

  function setSelectedTab(tab, index) {
    selectTab.value.name = tab
    selectTab.value.index = index
  }

  function clearSelectedTab() {
    selectTab.value = null
  }

  function crudNote() {
    newNoteCreated.value = !newNoteCreated.value
  }

  function setDeleteNote() {
    deleteNote.value = true
  }

  function clearDeleteNote() {
    deleteNote.value = false
  }

  const employerStore = useEmployerStore()
  const { actualEmployer, userData, actualPlanYearId } = storeToRefs(employerStore)


  function startCreatingNote() {
    isCreatingNote.value = true
  }

  function cancelCreatingNote() {
    isCreatingNote.value = false
  }

  async function getEmployerNotes() {
    try {

      if (!actualEmployer.value) {
        handleErrors('getEmployerNotes', new Error('Actual employer not found to get employer notes'))
        return
      }
      const response = await simpleGet(
        'getEmployerNotes',
        `${functionsBaseUrl}/notesGateway/api/v1/employers/notes?plan_year_id=${actualPlanYearId.value}`
      )

      employerNotes.value = response.data.results
      employerNotes.value = employerNotes.value
        .filter(
          (obj) =>
            obj.note !== ' ' && obj.note !== '' && obj.note !== undefined && obj.note !== null
        )
        .map((note) => ({
          ...note,
          category: 'General',
          dateFormatted: convertDate(note.date),
          user: userData.value?.fullname
        }))
      return response.data.results
    } catch (error) {
      handleErrors('getEmployerNotes', error)
    }
  }

  async function createEmployerNote(data) {
    try {
      const response = await post('createEmployerNote', `${functionsBaseUrl}/notesGateway/api/v1/employers/notes`, data)
      employerNotes.value.push(data)
      return response.data.results
    } catch (error) {
      handleErrors('createEmployerNote', error)
    }
  }

  async function editEmployerNote(id, data) {
    try {
      const response = await put('editEmployerNote', `${functionsBaseUrl}/notesGateway/api/v1/employers/notes/${id}`, data)
      const noteIndex = employerNotes.value.findIndex((note) => note.id === id)
      if (noteIndex !== -1) {
        employerNotes.value[noteIndex] = { ...employerNotes.value[noteIndex], ...data, id }
        const GENERAL_NOTES_UPDATED = '9'
        await createLog({
          eventId: GENERAL_NOTES_UPDATED,
          logName: 'user_activity_log_v2',
          employerId: actualEmployer.value.id,
          planYearId: actualEmployer.value.planYearId,
          agencyId: actualEmployer.value.agency_id
        })
      }
      return response.data.results
    } catch (error) {
      handleErrors('editEmployerNote', error)
    }
  }

  async function deleteEmployerNote(id) {
    try {
      const response = await del('deleteEmployerNote', `${functionsBaseUrl}/notesGateway/api/v1/employers/notes/${id}`)
      const index = employerNotes.value.findIndex((note) => note.id === id)
      if (index !== -1) {
        employerNotes.value.splice(index, 1)
      }
      return response.data.results
    } catch (error) {
      handleErrors('deleteEmployerNote', error)
    }
  }

  return {
    selectedNote,
    isCreatingNote,
    newNoteCreated,
    employerNotes,
    deleteNote,
    userData,
    selectTab,
    setSelectedNote,
    clearSelectedNote,
    startCreatingNote,
    cancelCreatingNote,
    getEmployerNotes,
    createEmployerNote,
    crudNote,
    deleteEmployerNote,
    editEmployerNote,
    setDeleteNote,
    clearDeleteNote,
    convertDate,
    setSelectedTab,
    clearSelectedTab
  }
})
